// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"223":"520a4d40","383":"1a1cc71a","393":"3b8a1819","659":"2d471b55","672":"9a1e5fa5"}[chunkId] + ".css";
};